import { Component, OnInit } from '@angular/core';
import { NotasService } from '../../service/notas.service';
import { NavigationEnd, Router } from "@angular/router";
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../service/seo.service';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notas',
  templateUrl: './notas.component.html',
  styleUrls: ['./notas.component.css']
})
export class NotasComponent implements OnInit {
    private subscription: Subscription = new Subscription();
    notas!:any[];
    newstr: any;
    pageActual: number = 1;
    RouteText : any;
    tituloseo: any;
    urlcanonicaseo: any;
    imagenseo: any;
    keywordsseo: any;
    descripcionseo: any;
    isFocus!: boolean;
    
    constructor(
        private _notasService:NotasService,
        private router: Router,
        private meta: Meta,
        private title: Title,
        private _seoService: SeoService,
        private _urlcanonicaservice: UrlcanonicaService
        
    ){
        
        this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.RouteText = event;
            this.getSEO(event.url)
        });
        
        this.getNotas();
    }

    onBlur(event: any) {
        setTimeout(() => {
          this.isFocus = false;
        }, 500);
    }

    getNotas(){
        this._notasService.getNotas().subscribe((resp:any)=>{
            this.notas=resp;
        })
    }

    buscador(termino: string) {
        this.isFocus = true;
        if (termino.length >= 3) {
    
          
          this.subscription.add(
            this._notasService.buscador(termino).subscribe((resp: any) => {
                console.log(resp.length)
                if(resp.length > 0){
                    this.notas=resp.reverse();
                }else{
                    this.notas=resp.reverse();
                }
            })
          );
        }
      }

    getSEO(page: string){
        this._seoService.getSEO(page).subscribe((resp: any) => {
        this.tituloseo = resp?.titulo;
        this.descripcionseo = resp?.descripcion;
        this.urlcanonicaseo =  resp?.urlcanonica;
        this.imagenseo = resp?.imagen; 

        this._urlcanonicaservice.createCanonicalLink();
        this.title.setTitle(this.tituloseo)
        this.meta.updateTag({
            name: 'description',
            content:
            this.descripcionseo
        })

        this.meta.updateTag({ property: 'twitter:card', content: 'summary' })
        this.meta.updateTag({ property: 'twitter:site', content: '@fundacionbest' })
        this.meta.updateTag({ property: 'twitter:title', content: 'Fundación BEST' })
        this.meta.updateTag({
            property: 'twitter:description',
            content:
            this.descripcionseo
        })
        this.meta.updateTag({
            property: 'twitter:image',
            content:
            this.imagenseo
        })

        this.meta.updateTag({
            property: 'og:url',
            content: 'https://fundacionbest.org.mx/notas'
        })
        this.meta.updateTag({ property: 'og:title', content: this.tituloseo })
        this.meta.updateTag({
            property: 'og:image',
            content:
            this.imagenseo
        })
        this.meta.updateTag({
            property: 'og:description',
            content:
            this.descripcionseo
        })       
        });
    }
    
    ngOnInit(): void {
      
    }
}
